export default "__VITE_ASSET__ki3SXJPr__"